var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefit6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5998 11C11.2763 11 11.0139 11.2686 11.0139 11.6V17.6857C11.0139 18.0171 11.2763 18.2857 11.5998 18.2857H16.6217C16.9453 18.2857 17.2076 18.0171 17.2076 17.6857V11.6C17.2076 11.2686 16.9453 11 16.6217 11H11.5998ZM19.3837 11C19.0602 11 18.7979 11.2686 18.7979 11.6V15.4857C18.7979 15.8171 19.0602 16.0857 19.3837 16.0857H26.0517C26.3752 16.0857 26.6375 15.8171 26.6375 15.4857V11.6C26.6375 11.2686 26.3752 11 26.0517 11H19.3837ZM20.5555 22.5143C20.5555 22.1829 20.8178 21.9143 21.1414 21.9143H26.0517C26.3752 21.9143 26.6375 22.1829 26.6375 22.5143V26.4C26.6375 26.7314 26.3752 27 26.0517 27H21.1414C20.8178 27 20.5555 26.7314 20.5555 26.4V22.5143ZM11.5998 20.1714C11.2763 20.1714 11.0139 20.4401 11.0139 20.7714V24.0857C11.0139 24.4171 11.2763 24.6857 11.5998 24.6857H16.5101C16.8337 24.6857 17.096 24.4171 17.096 24.0857V20.7714C17.096 20.4401 16.8337 20.1714 16.5101 20.1714H11.5998ZM24.8243 19.7143L24.4615 20.0858C24.2382 20.3146 24.2382 20.6854 24.4615 20.9142C24.6849 21.1429 25.047 21.1429 25.2704 20.9142L27 19.1429L25.2704 17.3716C25.047 17.1428 24.6849 17.1428 24.4615 17.3716C24.2382 17.6003 24.2382 17.9711 24.4615 18.1999L24.7964 18.5429H18.1004V25.8143H11.5719C11.2561 25.8143 11 26.0765 11 26.4C11 26.7235 11.2561 26.9857 11.5719 26.9857H19.2442V19.7143H24.8243Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit6);
export default __webpack_public_path__ + "static/media/benefit-6.4e855bffc43841fc86bb61c10ec3e30f.svg";
export { ForwardRef as ReactComponent };